import { OnboardingAuditFieldIdentifier, useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { FormValues } from './schema';

export const useInitialValues = (fieldIdentifier: OnboardingAuditFieldIdentifier): FormValues => {
    const { data } = useRepositorySuspenseQuery(
        'enterprises',
        'getOnboardingAuditOverride',
        {
            fieldIdentifiers: [fieldIdentifier],
        },
        { select: (result) => result.onboardingAuditOverrides[0] }
    );

    return {
        notes: data?.notes ?? '',
        overrideStatus: data?.overrideStatus ?? null,
    };
};
